(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('ColorService', ColorService);

    ColorService.$inject = ['ColorFactoryAdmin'];

    function ColorService(ColorFactoryAdmin) {
        var service = {
            getColorsByCurrentStore: getColorsByCurrentStore,
            findColor: findColor,
            createColor: createColor,
            getColorById: getColorById,
            removeColor: removeColor,
            editColor: editColor
        };

        return service;

        function getColorsByCurrentStore() {
            return ColorFactoryAdmin.getColorsByCurrentSTore().$promise;
        }

        function findColor(searchTerm) {
            var term = searchTerm === undefined || searchTerm === null ? "" : searchTerm;
            return ColorFactoryAdmin.findColor({ "name": term, "erpCode": term }).$promise;
        }

        function createColor(colorData) {
            return ColorFactoryAdmin.createColor(colorData).$promise;
        }

        function getColorById(colorId) {
            return ColorFactoryAdmin.getColorById({"colorId": colorId}).$promise;
        }

        function removeColor(colorId) {
            return ColorFactoryAdmin.removeColor({"colorId": colorId}).$promise;
        }

        function editColor(color) {
            return ColorFactoryAdmin.editColor({"colorId": color.id}, color).$promise;
        }

    }
})();
